import Bout from "../../../bout/Bout.js";
import Game from "../../../Game.js";
import ItemProviders from "../../../items/ItemProviders.js";
import Helper from "../../../utils/helper/Helper.js";
import ItemSlot from "../../itemSlot/ItemSlot.js";

export default class Inventory {
	constructor(callback) {
		this.callback = callback;
		Inventory.IDS = 0;
		this.typeContainer = "inventory";

	}

	init() {
		this.mc = jQuery("#template-inventory").clone();
		this.mc.attr("id", "invent" + Inventory.ENUM++);
		this.build();
		this.updateWeight();
		this.updateCoin();
	}
	getClip() {
		return this.mc;
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	build() {
		this.slots = new Array();
		for (let row = 0; row < Inventory.SLOTS / Inventory.PER_LINES; row++) {
			for (let col = 0; col < Inventory.PER_LINES; col++) {
				let id = "inv" + Inventory.IDS;
				Inventory.IDS++;
				let itemSlot = new ItemSlot(id, this.createSlot(id, row, col), null, null, this.itemSlotEventsHandler.bind(this))
				//this.slots.push({ id: "" + id, slot: this.createSlot(id, row, col), item: null });
				this.slots.push(itemSlot);
			}
		}
	}

	itemSlotEventsHandler(e) {
		e.data.from = this;
		this.dispatch(e);
	}

	createSlot(id, row, col) {
		let slot = jQuery("#template-slot-inventory").clone();
		slot.attr("id", "sloinv" + Inventory.ENUM++);
		slot.attr("data-ref", id);
		jQuery(".js-slots", this.mc).append(slot);
		jQuery(".js-empty", slot).css("background-image", "url('" + "./assets/ui/empty_slot.png" + "')");
		jQuery(".js-over", slot).css("background-image", "url('" + "./assets/ui/highlight_slot.png" + "')");
		jQuery(".js-filled", slot).css({ width: Game.TILE_WIDTH, height: Game.TILE_HEIGHT, left: (Inventory.DIM_SLOT - Game.TILE_WIDTH) / 2, top: (Inventory.DIM_SLOT - Game.TILE_HEIGHT) / 2 });
		slot.css({
			top: row * Inventory.DIM_SLOT + Inventory.SPAN_Y * row,
			left: col * Inventory.DIM_SLOT + Inventory.SPAN_X * col
		})

		return slot;
	}

	addItem(item, containerPos) {
		let retItem = null;
		let itemSlot;
		if (containerPos === -1) {

			// Primo libero o primo stack
			for (let x = 0; x < this.slots.length; x++) {
				itemSlot = this.slots[x];
				if (item.isStackable()) {
					if (itemSlot.item) {
						//console.log(itemSlot.item.isStackable(), itemSlot.item.id , item.id)
						if (itemSlot.item.template_id === item.template_id) {
							// lo stackka
							itemSlot.item.addStackQuantity(1);
							itemSlot.updateQuantity();
							this.updateWeight();
							return;
						}
					}
				}
			}

			for (let x = 0; x < this.slots.length; x++) {
				itemSlot = this.slots[x];
				if (!itemSlot.item) {
					break;
				}
			}
		} else {
			// posizione esatta
			for (let x = 0; x < this.slots.length; x++) {
				itemSlot = this.slots[x];
				if (itemSlot.id === containerPos) {
					break;
				}
			}
		}

		if (itemSlot) {
			if (!item.isType(ItemProviders.TYPE_MONEYS)) {
				if (itemSlot.hasItem()) {
					retItem = itemSlot.getItem();
				}
				itemSlot.setItem(item);
			} else {
				Bout.that.data.player.addCoin(item);
				Bout.that.removeFromInventory(item);
			}
			this.updateWeight();
			this.updateCoin();

		}

		return retItem;
	}


	removeItem(item) {
		for (let x = 0; x < this.slots.length; x++) {
			let itemSlot = this.slots[x];
			if (itemSlot.id === item.containerPos) {
				itemSlot.removeItem(item);
				break;
			}
		}
		this.updateWeight();
		this.updateCoin();

	}

	updateWeight() {
		let w = this.getWeight();
		jQuery(".js-weight", this.mc).text(Helper.toWeight(w));
		jQuery(".js-weight-total", this.mc).text(Helper.toWeight(Bout.that.data.player.max_weight));
	}

	getWeight() {
		let w = 0
		for (let x = 0; x < this.slots.length; x++) {
			let item = this.slots[x].getItem();
			if (item) {
				w += item.weight * item.getStackQuantity();
			}
		}
		return w;
	}

	getMaxWeight() {
		return Bout.that.data.player.max_weight;
	}

	updateCoin() {
		let gold = Bout.that.data.player.coin;
		jQuery(".js-coin", this.mc).text(Helper.toCoin(gold));
	}

	destroy() {
		Inventory.IDS = 0;
	}


	getItemsSlots() {
		return this.slots;
	}

	findSlotItemSameTemplate(template_id) {
		let a = this.getItemsSlots();
		for (let x = 0; x < a.length; x++) {
			if (a[x].hasItem()) {
				if (a[x].getItem().template_id === template_id) {
					return a[x];
				}
			}
		}
		return null;
	}

	findFirstEmptySlotItem(diff = 0) {
		//console.log(diff);
		let a = this.getItemsSlots();
		let n = -1;
		for (let x = 0; x < a.length; x++) {
			if (!a[x].hasItem()) {
				n++;
				if (n === diff) {
					return a[x];
				}
			}
		}
		return null;
	}



}
Inventory.IDS = 0;
Inventory.ENUM = 0;
Inventory.SLOTS = 40;
Inventory.PER_LINES = 5;
Inventory.DIM_SLOT = 36;
Inventory.SPAN_X = 10;
Inventory.SPAN_Y = 4;